import React from 'react';

const FacultyPage = () => {
  return (
    <div className="min-h-screen pt-32 pb-16" data-testid="faculty-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-6xl font-bold mb-4" data-testid="faculty-title">
            Distinguished <span className="gradient-text">Faculty</span>
          </h1>
          <p className="text-lg text-slate-300">
            Learn from the best minds in ophthalmology
          </p>
        </div>

        <div className="glass-card p-12 md:p-16 text-center neon-glow">
          <div className="w-32 h-32 mx-auto mb-8 rounded-full bg-gradient-to-br from-[#FF6F4A] to-[#FFB6C1] flex items-center justify-center float-animation">
            <span className="text-5xl">👨‍⚕️</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 gradient-text">
            Coming Soon!
          </h2>
          <p className="text-xl text-slate-300 mb-4">
            Our distinguished faculty lineup will be announced soon.
          </p>
          <p className="text-lg text-slate-400 mb-8">
            We are bringing together renowned national and international experts 
            from various subspecialties of ophthalmology.
          </p>
          <div className="glass-card inline-block px-8 py-4">
            <p className="text-[#FF6F4A] font-semibold">
              Stay tuned for exciting announcements!
            </p>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="glass-card p-6 text-center hover:scale-105 transition-transform duration-300">
            <div className="text-4xl mb-4">🔬</div>
            <h3 className="text-xl font-semibold mb-2">Cataract & Refractive</h3>
            <p className="text-sm text-slate-400">Expert speakers to be announced</p>
          </div>
          <div className="glass-card p-6 text-center hover:scale-105 transition-transform duration-300">
            <div className="text-4xl mb-4">👁️</div>
            <h3 className="text-xl font-semibold mb-2">Retina & Glaucoma</h3>
            <p className="text-sm text-slate-400">Expert speakers to be announced</p>
          </div>
          <div className="glass-card p-6 text-center hover:scale-105 transition-transform duration-300">
            <div className="text-4xl mb-4">💉</div>
            <h3 className="text-xl font-semibold mb-2">Cornea & Oculoplasty</h3>
            <p className="text-sm text-slate-400">Expert speakers to be announced</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacultyPage;
